export default {
  apiKey: 'AIzaSyAp0koWjzsIFU8FO8iPpeaJh_lOA5wO4kI',
  authDomain: 'granaquestbackend.firebaseapp.com',
  databaseURL: 'https://granaquestbackend.firebaseio.com',
  projectId: 'granaquestbackend',
  storageBucket: 'granaquestbackend.appspot.com',
  messagingSenderId: '924868755669',
  appId: '1:924868755669:web:ce6271bf6f248b3944225c',
};
